import Dialog from "components/Overlays/ResponsiveDialog";
import { FiAlertTriangle } from "react-icons/fi";
import useDeleteAccount from "api/UserResource/useDeleteAccount";
import { dataThatCannotBeRecovered } from "utils";

const DeleteAccount = ({ visible, onHide }) => {
	const { mutateAsync, isLoading } = useDeleteAccount();
	return (
		<Dialog
      sheet={false}
			header="Delete your account?"
			visible={visible}
			onHide={() => {
				if (!isLoading) onHide();
			}}
			className="account-dialog"
			maskClassName="account-dialog-mask"
			draggable={false}
			resizable={false}
			blockScroll
			closable={!isLoading}
			closeOnEscape={!isLoading}
			ariaCloseIconLabel="Cancel account deletion"
			footer={
				<div className="account-dialog-footer">
					<button
						type="button"
						className="account-button secondary"
						disabled={isLoading}
						onClick={onHide}
					>
						Keep my account
					</button>
					<button
						type="button"
						className="account-button danger"
						disabled={isLoading}
						onClick={async () => {
							try {
								await mutateAsync();
							} catch (_) {
								/* The mutation displays errors. */
							}
						}}
					>
						{isLoading ? "Deleting…" : "Delete permanently"}
					</button>
				</div>
			}
		>
			<div className="account-dialog-copy">
				<div className="account-note">
					<FiAlertTriangle aria-hidden="true" />
					<div>
						<strong>This can’t be undone</strong>Your account and its information will be
						permanently removed.
					</div>
				</div>
				<p className="mt-4">You will lose access to:</p>
				<ul>
					{dataThatCannotBeRecovered.map((item) => (
						<li key={item}>{item}</li>
					))}
				</ul>
				<p>Please make sure you’re ready before continuing.</p>
			</div>
		</Dialog>
	);
};
export default DeleteAccount;
